<div class="container session-types-page">
  <app-general-header
    [title]="'Manage ' + ((district && district.title) || 'District')" />
  <app-settings-nav [districtCode]="districtCode" />
  <div class="card border-0 p-3 session-types-container">
    <ng-container *ngIf="district">
      <!-- Only the first load swaps in the loader. Reloads after hide/restore/save
           keep the toolbar rendered so the search, layout filter and sort stay in
           sync with what's applied. -->
      <ng-container *ngIf="!isLoading || sessionTypes; else loadingTemplate">
        <div class="row d-flex justify-content-between my-3">
          <div class="col-12 col-md-6 d-flex flex-column flex-sm-row gap-2">
            <div class="table-search">
              <input
                type="search"
                class="form-control"
                placeholder="Search Session Types"
                aria-label="Search"
                (input)="searchTermChanged($event)" />
            </div>
            <div class="layout-filter">
              <select
                class="form-select"
                aria-label="Filter by layout"
                (change)="layoutFilterChanged($event)">
                <option value="">All Layouts</option>
                <option
                  *ngFor="let option of layoutFilterOptions"
                  [value]="option.label">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end mt-2 mt-md-0 py-3 py-md-0">
            <button
              type="button"
              class="btn btn-primary btn-create-session-type"
              (click)="openCreateModal()">
              <i class="bi bi-plus"></i>
              Create a Session Type
            </button>
          </div>
        </div>

        <div class="table-wrapper w-100">
          <table class="table">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="col-name"
                  (sort)="onSort($event)"
                  sortable="title">
                  Name
                  <i class="bi bi-caret-down {{ sortIconTemp.title }}"></i>
                </th>
                <th
                  scope="col"
                  class="col-layout"
                  (sort)="onSort($event)"
                  sortable="layout">
                  Layout
                  <i class="bi bi-caret-down {{ sortIconTemp.layout }}"></i>
                </th>
                <th scope="col" class="text-center col-coaching">Coaching</th>
                <th scope="col" class="text-center col-shared">Shared</th>
                <th
                  scope="col"
                  (sort)="onSort($event)"
                  sortable="activityCount"
                  class="text-center col-activity">
                  Activity
                  <i
                    class="bi bi-caret-down {{
                      sortIconTemp.activityCount
                    }}"></i>
                </th>
                <th scope="col" class="actions-col"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="activeTypes.length > 0; else noSessionTypes">
                <tr *ngFor="let sessionType of activeTypes">
                  <td class="col-name">
                    <span class="fw-bold">{{ sessionType.title }}</span>
                    <p *ngIf="sessionType.description" class="description mb-0">
                      {{ sessionType.description }}
                    </p>
                  </td>
                  <td class="col-layout">
                    <div class="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        class="layout-swatch-btn"
                        ngbTooltip="Preview layout"
                        (click)="openPreviewModal(sessionType)">
                        <img
                          class="layout-swatch"
                          [src]="getLayoutThumbnail(sessionType)"
                          alt="" />
                        <span class="layout-swatch-hover">
                          <i class="bi bi-eye"></i>
                        </span>
                      </button>
                      <span class="layout-label">{{
                        getLayoutLabel(sessionType)
                      }}</span>
                    </div>
                  </td>
                  <td class="text-center col-coaching">
                    <ng-container
                      *ngIf="
                        sessionType.isCoaching;
                        then checkIcon;
                        else dash
                      "></ng-container>
                  </td>
                  <td class="text-center col-shared">
                    <ng-container
                      *ngIf="
                        sessionType.isShared;
                        then checkIcon;
                        else dash
                      "></ng-container>
                  </td>
                  <td class="text-center col-activity activity-count">
                    {{
                      sessionType.activityCount === undefined
                        ? "—"
                        : sessionType.activityCount + " sessions"
                    }}
                  </td>
                  <td class="actions-col">
                    <div class="d-flex align-items-center">
                      <i
                        *ngIf="isOwnedByCurrentDistrict(sessionType)"
                        (click)="openEditModal(sessionType)"
                        ngbTooltip="Edit session type"
                        class="bi bi-pencil cursor-pointer color-tertiary"></i>
                      <i
                        (click)="openHideModal(sessionType)"
                        ngbTooltip="Hide session type"
                        class="bi bi-eye-slash cursor-pointer color-tertiary ms-auto"></i>
                    </div>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noSessionTypes>
                <tr>
                  <td colspan="6">
                    <div
                      class="d-flex flex-column align-items-center justify-content-center w-100"
                      style="min-height: 400px">
                      <h2>No Session Types Found</h2>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>

        <ng-container *ngIf="hiddenTypes.length > 0">
          <div ngbAccordion>
            <div ngbAccordionItem [collapsed]="false">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="hidden-divider">
                  <i class="bi bi-eye-slash me-1"></i>HIDDEN — NOT AVAILABLE TO
                  ASSIGN
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="table-wrapper w-100">
                      <table class="table hidden-table">
                        <tbody>
                          <tr *ngFor="let sessionType of hiddenTypes">
                            <td class="col-name">
                              <div class="d-flex align-items-center gap-2">
                                <span class="fw-semibold">{{
                                  sessionType.title
                                }}</span>
                                <span class="badge hidden-badge">HIDDEN</span>
                              </div>
                              <p
                                *ngIf="sessionType.description"
                                class="description mb-0">
                                {{ sessionType.description }}
                              </p>
                            </td>
                            <td class="col-layout">
                              <div class="d-flex align-items-center gap-2">
                                <button
                                  type="button"
                                  class="layout-swatch-btn"
                                  ngbTooltip="Preview layout"
                                  (click)="openPreviewModal(sessionType)">
                                  <img
                                    class="layout-swatch desaturated"
                                    [src]="getLayoutThumbnail(sessionType)"
                                    alt="" />
                                  <span class="layout-swatch-hover">
                                    <i class="bi bi-eye"></i>
                                  </span>
                                </button>
                                <span class="layout-label">{{
                                  getLayoutLabel(sessionType)
                                }}</span>
                              </div>
                            </td>
                            <td class="text-center col-coaching">
                              <ng-container
                                *ngIf="
                                  sessionType.isCoaching;
                                  then checkIcon;
                                  else dash
                                "></ng-container>
                            </td>
                            <td class="text-center col-shared">
                              <ng-container
                                *ngIf="
                                  sessionType.isShared;
                                  then checkIcon;
                                  else dash
                                "></ng-container>
                            </td>
                            <td class="text-center col-activity activity-count">
                              {{
                                sessionType.activityCount === undefined
                                  ? "—"
                                  : sessionType.activityCount + " sessions"
                              }}
                            </td>
                            <td class="text-end actions-col">
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm restore-btn"
                                (click)="onRestore(sessionType)">
                                Restore
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <p class="summary-count mt-2 mb-0">
          {{ activeTypes.length }} active &middot;
          {{ hiddenTypes.length }} hidden &middot;
          {{ activeTypes.length + hiddenTypes.length }} total session types
          assigned to {{ district.title }}
        </p>
      </ng-container>
    </ng-container>
  </div>
</div>

<app-hide-session-type-modal
  #hideSessionTypeModal
  (confirmHide)="onConfirmHide($event)"></app-hide-session-type-modal>

<app-create-edit-session-type-modal
  #createEditSessionTypeModal
  [district]="district"
  (sessionTypeSaved)="getSessionTypes()"></app-create-edit-session-type-modal>

<app-session-type-preview-modal
  #sessionTypePreviewModal></app-session-type-preview-modal>

<ng-template #loadingTemplate>
  <div class="w-100" style="height: 700px">
    <app-loader></app-loader>
  </div>
</ng-template>

<ng-template #checkIcon
  ><i class="bi bi-check2-circle text-info"></i
></ng-template>
<ng-template #dash><span class="dash">—</span></ng-template>
